module.exports = __webpack_public_path__ + "img/014-wales.86b5079c.svg";